import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import Card from '../Card';
import StatisticCharts from '../StatisticCharts';
import SectionTitle from '../SectionTitle';
import MediaChartsLogged from '../MediaChartsLogged';
import { reports, reportsList } from '../../../services/api';
import Leads from '../Leads';
import * as Style from './style';
import color from '../../../config/colors.json';

const Charts = () => {
    const [timeline, setTimeline] = useState({
        data: [],
        error: false,
    });
    const [impressions, setImpressions] = useState({
        data: null,
        error: false,
    });
    const [clicks, setClicks] = useState({
        data: null,
        error: false,
    });
    const [ctr, setCtr] = useState({
        data: null,
        error: false,
    });
    const [preSaleId] = useState('');
    const [campaignTitle] = useState('Campanha de Google');
    const [campaignData, setCampaignData] = useState([]);
    const [hasPlan] = useState(!!preSaleId);

    const loadData = (type, setState) => {
        setState({ data: (setState === setTimeline ? [] : null) });

        reports(preSaleId, type)
        .then((res) => {
            const resData = type === 'timeline' ? res.data : res.data[0][type];
            setState({ data: resData });
        })
        .catch(() => setState({ data: 0, error: true }));
    };

    useEffect(() => {
        reportsList.recurrent().then((res) => {
            setCampaignData(res.data.demands);
            const repData = res.data.demands.filter(demand => demand.attributes.id === preSaleId);
            setCampaignData(repData);
        });

        if (preSaleId !== '') {
            loadData('timeline', setTimeline, preSaleId);
            loadData('impressions', setImpressions, preSaleId);
            loadData('clicks', setClicks, preSaleId);
            loadData('ctr', setCtr, preSaleId);
        }
    }, [preSaleId]);

    const history = useHistory();
    // eslint-disable-next-line no-unused-vars
    const campaignDetail = () => {
		TagManager.dataLayer({
			dataLayer: {
				event: 'trackEvent',
				actionButton: 'BTN-CAM-00-REPORT',
			},
			dataLayerName: 'Campanhas',
		});
        history.push(`relatorios/${preSaleId}`, { campaign: campaignData[0].attributes });
    };

    return (
	<>
		<Style.Container>
			<Style.Leads>
				<Leads
					title="Minhas conversões"
					subtitle="Conversões realizadas com base nos leads gerados pela campanha filtrada"
				/>
			</Style.Leads>
			<Style.StyledMediaCharts>
				<MediaChartsLogged />
			</Style.StyledMediaCharts>
		</Style.Container>
		<Card
			height="100%"
			padding="20px"
			border={`1px solid ${color.lightGrey43}`}
			noShadow
			margin="32px 0 0"
		>
			<SectionTitle
				title={campaignTitle}
				subtitle="Dados do investimento realizado em Google"
				titleHeight="20px"
				titleSize="14px"
				titleMarginBottom="0"
				subtitleHeight="20px"
				subtitleSize="14px"
				subtitleMarginBottom="0"
				marginBottom="33px"
				subtitleColor={color.dark2}
			/>
			<StatisticCharts
				impressions={impressions}
				clicks={clicks}
				timeline={timeline}
				ctr={ctr}
				hasPlan={hasPlan}
			/>
		</Card>
	</>
    );
};

export default Charts;
